import * as actions from "../reducers/loading";
import CS from "../../services/commonService";

//	actions to display success messages
const actionTypes = ["auth/setCurrentUser"];

const api =
	({ dispatch }) =>
	(next) =>
	async (action) => {
		if (!action.payload) return next(action);

		const { onSuccess } = action.payload;

		next(action);

		const response = null;
		if (response?.status) {
			if (actionTypes.includes(onSuccess))
				CS.showSuccessMessage(response.message);
			if (onSuccess) dispatch({ type: onSuccess, payload: response.data });
		}
	};

export default api;
